module.exports = __webpack_public_path__ + "static/media/purple_mark_icon.1412b929.svg";